import { render, staticRenderFns } from "./ServiceProtocol.vue?vue&type=template&id=a3bcdfa4&"
import script from "./ServiceProtocol.vue?vue&type=script&lang=js&"
export * from "./ServiceProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports